<kendo-dialog
	*ngIf="dialogOpened"
	title="Confirm Language Change"
	(close)="close('dialog')"
	[minWidth]="350"
	[width]="475">
	<div class="switch-dialog">
		<p>Changing the application language will delete all partially completed courses. You will need to restart any in-progress courses, and additional license costs may apply.</p>
		<div>
			<div class="k-checkbox-wrap">
				<input
					#acceptAgreement
					required
					type="checkbox"
					[(ngModel)]="isResetTrainingsEnabled"
					kendoCheckBox />
				<kendo-label
					style="margin: 18px 0 0 8px"
					[for]="acceptAgreement"
					text="I acknowledge all partially completed trainings will be permanently deleted."></kendo-label>
			</div>
		</div>
	</div>
	<kendo-dialog-actions [layout]="'start'">
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Cancel
		</button>
		<button
			kendoButton
			kpaKendoButton="primary"
			[disabled]="!isResetTrainingsEnabled"
			(click)="switchLanguage()">
			Change Language
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
